<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div v-if="true">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              {{closeObj.title}}
            </div>
            <v-spacer/>
            <div class="mr-4 mt-4" v-if="getDetailBasic.tag === 'E8'">
              <div v-if="getDetailChar.stat === true">
                Verified
              </div>
              <div v-else>
                Review
              </div>
            </div>
          </v-layout>
        </div>
        <div v-if="getDetailBasic.tag === 'S6'">
          <v-layout row wrap class="ml-2 mr-2 mb-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="method"
                :label="this.localForm.method"
                :items="investigationMethodOptions"
                color="wplblue0"
                prepend-icon="format_list_numbered"
                hint="investigation method"
                persistent-hint
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="cause"
                :items="causeOptions"
                :menu-props="{ maxHeight: '400' }"
                label="Select"
                multiple
                prepend-icon="hdr_weak"
                hint="incident causes"
                persistent-hint
              ></v-select>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="this.getDetailBasic.tag === 'S6'">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              {{closeObj.description}}
            </div>
          </v-layout>
        </div>
        <div v-if="true">
          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.close"
              :disabled="this.disableEdit"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              :hint="closeObj.hintclose"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="this.getDetailBasic.tag === 'E8'">
          <v-layout row wrap class="ml-2 mr-2">
            <v-spacer/>
            <v-btn :disabled="
            !this.enableConfirm ||
            !this.opsStatus ||
            this.disableEdit"
            :color="ui.btnColor" flat dark @click="confirmNotification()">
              <v-icon left>
                verified
              </v-icon>
              Verify Technical Result
            </v-btn>
          </v-layout>
        </div>
        <div v-if="true">
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm6 md6 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="out"
                :label="this.localForm.out"
                :items="closeQualityTypeOptions"
                color="wplblue0"
                prepend-icon="lightbulb"
                hint="outcome"
                :disabled="this.disableEdit"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 sm6 md6
            v-if="
            this.getDetailBasic.tag !== 'W1' &&
            this.getDetailBasic.tag !== 'W2' &&
            this.getDetailBasic.tag !== 'M7'">
              <v-select
                :change="updateFormChar()"
                v-model="rec"
                :label="this.localForm.rec"
                :items="recommendationTypeOptions"
                color="wplblue0"
                :disabled="this.disableEdit"
                prepend-icon="medication"
                hint="recommendation"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6
            v-if="
            this.getDetailBasic.tag === 'W1' ||
            this.getDetailBasic.tag === 'W2' ||
            this.getDetailBasic.tag === 'M7'
            ">
              <v-select
                :change="updateFormChar()"
                v-model="qa"
                :label="this.localForm.qa"
                :items="workQualityOptions"
                color="wplblue0"
                prepend-icon="new_releases"
                hint="quality"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-select
                v-if="this.getDetailBasic.tag === 'S6'"
                :change="updateFormChar()"
                v-model="system"
                :label="this.localForm.system"
                :items="reachBusinessOperationsOptions"
                color="wplblue0"
                prepend-icon="trip_origin"
                hint="systemic"
                persistent-hint
              >
              </v-select>
              <v-select
                v-if="this.getDetailBasic.tag === 'B3'"
                :change="updateFormChar()"
                v-model="reflect"
                :label="this.localForm.reflect"
                :items="closeReflectionOptions"
                color="wplblue0"
                prepend-icon="trip_origin"
                hint="reflection"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import incidentOptions from "@/data/options/mixins/incidentOptions.js";
import safetyOptions from "@/data/options/mixins/safetyOptions.js";
import workOptions from "@/data/options/mixins/workOptions.js";
import businessOptions from "@/data/options/mixins/businessOptions.js";
import ownerOptions from "@/data/options/mixins/ownerOptions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";

// import DatePicker from "@/data/functions/components/DatePicker";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      ctr: 0,
      enableConfirm: true,
      completeNotiBtnPressed: false,
      localForm: {
        cause: "",
        method: "",
        close: "",
        rec: "",
        qa: "",
        out: "",
        system: "",
        reflect: ""
      },
      orgForm: {
        cause: "",
        method: "",
        close: "",
        rec: "",
        qa: "",
        out: "",
        system: "",
        reflect: ""
      },
      cause: "",
      out: "",
      method: "",
      other: "", // potential impact
      rec: "",
      system: "",
      reflect: "",
      qa: ""
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.method = this.getDetail.char.method;
    this.localForm.out = this.getDetail.char.out;
    this.localForm.close = this.getDetail.char.close;
    this.localForm.rec = this.getDetail.char.rec;
    this.localForm.system = this.getDetail.char.system;
    this.localForm.reflect = this.getDetail.char.reflect;
    this.localForm.qa = this.getDetail.char.qa;

    this.orgForm.out = this.getDetail.char.out;
    this.orgForm.method = this.getDetail.char.method;
    this.orgForm.close = this.getDetail.char.close;
    this.orgForm.rec = this.getDetail.char.rec;
    this.orgForm.system = this.getDetail.char.system;
    this.orgForm.reflect = this.getDetail.char.reflect;
    this.orgForm.qa = this.getDetail.char.qa;

    if (this.getDetailBasic.tag !== "M7" && this.getDetailBasic.tag !== "E8") {
      this.cause = this.getDetailRelps.s7;
    }
  },
  watch: {
    cause() {
      this.localForm.cause = this.cause;
      this.updateFormRelps();
    },
    out() {
      this.localForm.out = this.out;
      this.updateFormChar();
    },
    method() {
      this.localForm.method = this.method;
      this.updateFormChar();
    },
    rec() {
      this.localForm.rec = this.rec;
      this.updateFormChar();
    },
    system() {
      this.localForm.system = this.system;
      this.updateFormChar();
    },
    reflect() {
      this.localForm.reflect = this.reflect;
      this.updateFormChar();
    },
    qa() {
      this.localForm.qa = this.qa;
      this.updateFormChar();
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    incidentOptions,
    safetyOptions,
    businessOptions,
    dateFunctions,
    ownerOptions,
    workOptions
  ],
  // components: {
  //   DatePicker
  // },
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getDetailRelps",
      "getCurrentPage",
      "getPreviousPage"
    ]),
    disableEdit() {
      let logic = null;
      if (this.getDetailBasic.tag === "E8") {
        if (
          this.getDetailChar.stat === true ||
          this.getPreviousPage === "/reportlist" ||
          this.getPreviousPage === "/reportdetaillist"
        ) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    },
    opsStatus() {
      let logic;
      if (this.getDetailChar.stat === true || this.completeNotiBtnPressed) {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    shareStatus() {
      let logic;
      if (this.getDetailChar.stat === true || this.completeNotiBtnPressed) {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    closeObj() {
      let obj = {
        title: "Detail",
        description: "investigation scope and description",
        reach: "reach",
        sponsor: "sponsor"
      };
      if (this.getDetailBasic.tag === "B1") {
        obj.title = "Investigation Detail";
        obj.description = "risk scope and limits";
        obj.reach = "risk cover";
        obj.sponsor = "risk ownership";
      }
      if (this.getDetailBasic.tag === "B3") {
        obj.title = "Action Results";
        obj.description = "action scope and limits";
        obj.hintclose = "action outcomes and results";
        obj.sponsor = "action sponsor";
      }
      if (this.getDetailBasic.tag === "B4") {
        obj.title = "Budget Reflections";
        obj.description = "action scope and limits";
        obj.hintclose = "budget results and lessons learnt";
        obj.sponsor = "action sponsor";
      }
      if (this.getDetailBasic.tag === "B6") {
        obj.title = "Plan Close Out";
        obj.description = "action scope and limits";
        obj.hintclose = "plan results and lessons learnt";
        obj.sponsor = "action sponsor";
      }
      if (this.getDetailBasic.tag === "E2") {
        obj.title = "Engineering Key Recommendation";
        obj.description = "action scope and limits";
        obj.hintclose = "technical study outcomes";
        obj.sponsor = "action sponsor";
      }
      if (this.getDetailBasic.tag === "E8") {
        obj.title = "Engineering Assessment";
        obj.description = "action scope and limits";
        obj.hintclose = "technical results assessment";
        obj.sponsor = "action sponsor";
      }
      if (this.getDetailBasic.tag === "M7") {
        obj.title = "Maintenance Call Review";
        obj.description = "review and audit";
        obj.hintclose = "review comments and analysis";
        obj.sponsor = "action sponsor";
      }
      if (this.getDetailBasic.tag === "S6") {
        obj.title = "Investigation Detail";
        obj.description = "Investigation Detail Description";
        obj.hintclose = "investigation description";
        obj.sponsor = "sponsor";
      }
      if (this.getDetailBasic.tag === "W1") {
        obj.title = "Work Request Close Out";
        obj.description = "action scope and limits";
        obj.hintclose = "plan results and lessons learnt";
        obj.sponsor = "action sponsor";
      }
      if (this.getDetailBasic.tag === "W2") {
        obj.title = "Work Call Close Out";
        obj.description = "work scope and limits";
        obj.hintclose = "plan results and lessons learnt";
        obj.sponsor = "action sponsor";
      }
      return obj;
    }
  },
  methods: {
    confirmNotification() {
      let char = this.getDetailChar;
      char.stat = true;
      // lock the button (one confirm at a time)
      this.enableConfirm = false;
      this.saveDocumentRevMod(4.11, 9); // business mod.
      this.$store.dispatch("changeDetailChar", char);
      this.$store.dispatch("changeDataSavePendingIndication", true);
    },
    updateFormRelps() {
      let relps = this.getDetailRelps;
      if (this.getDetailBasic.tag === "S6") {
        relps.s7 = this.cause;
        if (this.ctr > 1) {
          this.$store.dispatch("changeDataSavePendingIndication", true);
          this.$store.dispatch("changeDetailRelps", relps);
          this.saveDocumentRevMod(4.17, 1); // business mod.
        }
        // This conter ensure that the Hazard Contrl does not fire
        //  in the first page show
        this.ctr = this.ctr + 1;
      }
    },
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.method !== this.orgForm.method &&
        this.localForm.method !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.method = this.localForm.method;
        // basic
        char.method = this.localForm.method;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.out !== this.orgForm.out &&
        this.localForm.out !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.out = this.localForm.out;
        // basic
        char.out = this.localForm.out;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.close !== this.orgForm.close &&
        this.localForm.close !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.close = this.localForm.close;
        // basic
        char.close = this.localForm.close;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.system !== this.orgForm.system &&
        this.localForm.system !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.system = this.localForm.system;
        // basic
        char.system = this.localForm.system;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.rec !== this.orgForm.rec &&
        this.localForm.rec !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rec = this.localForm.rec;
        // basic
        char.rec = this.localForm.rec;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.reflect !== this.orgForm.reflect &&
        this.localForm.reflect !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.reflect = this.localForm.reflect;
        // basic
        char.reflect = this.localForm.reflect;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      // eslint-disable-next-line
      if (
        this.localForm.qa !== this.orgForm.qa &&
        this.localForm.qa !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.qa = this.localForm.qa;
        // basic
        char.qa = this.localForm.qa;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
